// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__StrPM","topCard":"styles_topCard__owYbo"};